import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader, Spinner } from "@/components/site/kit";
import { Reveal } from "@/components/motion/primitives";
import { getProjects } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";
import SEO, { breadcrumbSchema } from "@/components/site/SEO";

export default function Projects() {
  const [projects, setProjects] = useState(null);
  useEffect(() => { getProjects().then(setProjects).catch(() => setProjects([])); }, []);

  return (
    <div data-testid="projects-page">
      <SEO
        title="Projets & ventures — ce que Julius Mason construit"
        description="Au-delà des projets clients : Mason Academy, Free Tools Suite, The Marketing Notebook et autres ventures que je construis pour aider entrepreneurs et créateurs à grandir."
        path="/projects"
        keywords="julius mason projects, mason academy, free tools suite, marketing notebook, web developer ventures"
        schema={breadcrumbSchema([
          { name: "Accueil", path: "/" },
          { name: "Projets", path: "/projects" },
        ])}
      />
      <PageHeader
        chapter="Projects / Ventures"
        titleLines={["Things I'm", "building."]}
        description="Beyond client work, these are the ventures, open-source projects, and research initiatives I'm pouring energy into."
      />
      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-[1600px] px-5 md:px-10 grid md:grid-cols-2 gap-6">
          {!projects ? <div className="md:col-span-2"><Spinner /></div> : projects.map((p, i) => (
            <Reveal key={p.id} delay={(i % 2) * 0.1}>
              <Link to={`/projects/${p.id}`} data-testid={`project-card-${p.id}`} className="group block border border-border overflow-hidden hover-lift bg-card">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img src={p.image} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <span className="absolute top-4 left-4 font-mono text-xs bg-background/80 px-3 py-1 uppercase tracking-widest">{p.status}</span>
                </div>
                <div className="p-8">
                  <div className="flex items-start justify-between">
                    <h3 className="font-display text-3xl group-hover:text-primary transition-colors">{p.name}</h3>
                    <ArrowUpRight className="w-6 h-6 text-primary group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                  </div>
                  <p className="text-primary font-mono text-sm mt-1">{p.tagline}</p>
                  <p className="text-muted-foreground mt-4 leading-relaxed">{p.description}</p>
                  <div className="flex flex-wrap gap-2 mt-6">{(p.tags || []).map((t) => <span key={t} className="font-mono text-xs border border-border px-3 py-1">{t}</span>)}</div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
